import React, { useEffect, useState } from "react";
import { getLoginPage } from "../../Hooks/index";
import './Style/style.css'

const NoticeLogin = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(false);
      const result = await getLoginPage("00000000-0000-0000-0000-000000000000");
      setData(result);
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) return null;

  return (
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }} className="login-banner">
      {data?.imageUrl && (
        <img
          className="banner-image" // کلاس CSS برای تصویر
          src={data.imageUrl}
          alt={data?.imageName || 'Banner Image'} // اضافه کردن alt پیش‌فرض
        />
      )}
      {data?.description && (
        <div 
          className="banner-text font-num" // کلاس CSS برای متن
          dangerouslySetInnerHTML={{ __html: data.description }}
        />
      )}
    </div>
  );
};

export default NoticeLogin;
